import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BootstrapCompetitionDocumentsComponent } from './components/bootstrap-competition-documents/bootstrap-competition-documents.component';


const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CompetitionDocumentsRoutingModule { }
